import { render, staticRenderFns } from "./form-layout.vue?vue&type=template&id=254cbfe9&scoped=true"
import script from "./form-layout.vue?vue&type=script&lang=js"
export * from "./form-layout.vue?vue&type=script&lang=js"
import style0 from "./form-layout.vue?vue&type=style&index=0&id=254cbfe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254cbfe9",
  null
  
)

export default component.exports